
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/[sort_url]",
      function () {
        return require("private-next-pages/service/[sort_url].js");
      }
    ]);
  